import React from "react";
import { FaPhone, FaMapMarkerAlt, FaClock, FaFacebookF, FaWhatsapp, FaInstagram } from "react-icons/fa";
import { useContextUsuario } from "../../contexto/usuario/UsuarioContext";
import FooterNavItems from "./FooterNavItems";

const Footer = () => {
  const { usuario } = useContextUsuario();

  const navItemsEmpleados = [
    { url: "/app/admin/empleados/nuevo", nombre: "Empleados" },
    { url: "/app/admin/clientes/nuevo", nombre: "Clientes" },
    { url: "/app/admin/productos/nuevo", nombre: "Productos" },
    { url: "/app/admin/servicios/nuevo", nombre: "Servicios" },
    { url: "/app/admin/cotizaciones/nuevo", nombre: "Cotizaciones" },
    { url: "/app/admin/pedidos/nuevo", nombre: "Pedidos" },
  ];

  const navItemsClientes = [
    { url: "/app/clientes/cotizaciones/nuevo", nombre: "Cotizaciones" },
    { url: "/app/clientes/pedidos/nuevo", nombre: "Pedidos" },
  ];

  return (
    <footer className="main-footer py-4">
      <div className="container">
        <div className="row">
          {/* Información Principal */}
          <div className="col-md-4 mb-3">
            <h5 className="fw-bold">GRUPO ARESSA</h5>
            <p className="">
              IMPORTAMOS EN TU VIDA, IMPORTAMOS EN TU NEGOCIO
            </p>
          </div>

          {/* Navegación según usuario */}
          <div className="col-md-4 mb-3">
            <h6 className="fw-bold">Navegación</h6>
            <FooterNavItems items={usuario.tipo === "Empleado" ? navItemsEmpleados : navItemsClientes} />
          </div>

          {/* Datos de Contacto */}
          <div className="col-md-4 mb-3">
            <h6 className="fw-bold">Contacto</h6>
            <ul className="list-unstyled">
              <li className="mb-2 d-flex align-items-center">
                <FaPhone className="me-2 mx-2" />
                <a href="tel:+504-92866696" className="text-decoration-none">
                  +504-9286-6696
                </a>
              </li>
              <li className="mb-2 d-flex align-items-center">
                <FaPhone className="me-2 mx-2" />
                <a href="tel:+504-96692227" className="text-decoration-none">
                  +504-9669-2227
                </a>
              </li>
              <li className="mb-2 d-flex align-items-center">
                <FaPhone className="me-2 mx-2" />
                <a href="tel:+504-93407966" className="text-decoration-none">
                  +504-9340-7966
                </a>
              </li>
              <li className="mb-2 d-flex align-items-center">
                <FaMapMarkerAlt className="me-2 mx-2" />
                <a
                  href="https://maps.app.goo.gl/7mfzcN2p5viyA1df6"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  Carretera  Ca-5, 500 mts antes de la estacion de peaje Siguatepeque, Comayagua
                </a>
              </li>
              <li className="d-flex align-items-center">
                <FaClock className="me-2 mx-2" />
                <span className="">Lunes a Sabado de 8:00 am a 5:00 pm</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Redes Sociales */}
        <div className="text-center mt-4">
          <a href="https://www.facebook.com/p/Grupo-Aressa-61564159953415/" className="" target="_blank" rel="noopener noreferrer">
            <FaFacebookF size={27} />
          </a>
          <a href="https://wa.me/50492866696" className="mx-2" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp size={27} />
          </a>
          <a href="https://www.instagram.com/grupo.aressa?igsh=enJ3eWs4ZGMzMnEz" className="mx-2" target="_blank" rel="noopener noreferrer">
            <FaInstagram size={27} />
          </a>
        </div>

        {/* Derechos Reservados */}
        <div className="text-center mt-3">
          <p className="mb-0">
            &copy; 2025 GRUPO ARESSA. Todos los derechos reservados. Desarrollado por Desofiw.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
